import { Header } from '../components/Header';
import {Comment} from './Comment';
import React, {useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DOMPurify from 'dompurify';

import axios from 'axios';
import { 
    BASE_URL_API, 
    IMAGE_PATH, 
    BASE_URL_OPENFORGE, 
    CLIENT_ID, 
    CLIENT_SECRET, 
    DATA_DECRYPTION_KEY,
    SOP_CDN_PATH,
    CDN_ELK_URL,
    GIGW_Web_Accessibility,
    USER_MANUAL_CONTRIBUTOR_CDN_PATH
} from '../components/Constants';
import crypto from 'crypto-js';
import { decryptAES } from '../components/CryptoUtils';
import { useLocation } from "react-router-dom";
import { useUser } from '../ContextApi/UserContext';
import Toastify from 'toastify-js';
import 'toastify-js/src/toastify.css';
import "react-loading-skeleton/dist/skeleton.css";
import Skeleton, {SkeletonTheme} from 'react-loading-skeleton';

export const Detail = React.memo(() =>  {
    const { user, isLoggedIn} = useUser();
    //isLoggedIn = true;
    const location = useLocation();
    const  id  = useParams(); // Get the dynamic ID from the route
    const [isLoading, setIsLoading] = useState(false);
    //newCode for useNavigate
    // const [task, setTask] = useState(location?.state?.task || {});
    //API Task State Previous Code
    const [task, setTask] = useState([]);
    const [comments, setComments] = useState([]);
    const [text, setText] = useState("");
    const [commentCount, setCommentCount] = useState(0);
    
    //console.log("comments", comments);

    const handleLogin = () => {
        const redirectUrl = location?.pathname ? location.pathname : null;
          
          if(redirectUrl){
            localStorage.setItem("redirectUrl", redirectUrl);
          }
  
          //const redirectUrlGet = localStorage.getItem("redirectUrl");
          //const url = `${BASE_URL_OPENFORGE}${redirectUrlGet}`;
          
          window.location.href = `${BASE_URL_OPENFORGE}/account/login.php?requested_by=collabwithgov`;
      };

      function transformData(input) {   

        const inputComplexity = {
          Medium: input.complexity_counts.Medium,
          High: input.complexity_counts.High,
          Low: input.complexity_counts.Low,
        };
    
        const fetch_records = input.data.map((record) => ({
          artifact_id: record.artifact_id,
          real_name: record.real_name,
          submitted_on:record.submitted_on,
          tracker_id: record.tracker_id,
          user_name: record.user_name, 
          status : record.status,
          assign_to: {
            label: "Others",
            value: record.assign_to
              ? record.assign_to.split(",").map((item) => item.trim())
              : [], 
          },
          category: { label: "Category", value: [record.category] },
          complexity: { label: "Complexity Level", value: [record.complexity] },
          descriptions: { label: "Descriptions", value: [record.descriptions] },
          documents: { label: "Documents", value: [record.documents] },
          expected_outcome: { label: "Expected Outcome", value: [record.expected_outcome] },
          how_to_submit: { label: "How to Submit", value: [record.how_to_submit] },
          last_submission_date_1: { label: "Last Submission Date", value: [record.last_submission_date_1] },
          mentor_s_1: { label: "Others", value: [record.mentor_s_1] },
          mode_of_the_task: { label: "Others", value: [record.mode_of_the_task] },
          mode_of_the_task_1: { label: "Others", value: [record.mode_of_the_task_1] },
          product_name_1: { label: "Product Name", value: [record.product_name_1] },
          publisher_details: { label: "Publisher Details", value: [record.publisher_details] },
          reference_url: { label: "Reference URL", value: [record.reference_url] },
          repository_url: { label: "Repository URL", value: [record.repository_url] },
          skills_and_expertise: { label: "Skills and Expertise", value: [record.skills_and_expertise] },
          submitted_real_name: { label: "Others", value: [record.submitted_real_name] },
          submitted_user_name: { label: "Others", value: [record.submitted_user_name] },
          title: { label: "Title", value: [record.title] },
          what_you_ll_do: { label: "Others", value: [record.what_you_ll_do] },
        }));
      
        return {
          fetch_records,
          total_complexity : [
            { label: "All", label_count: inputComplexity.Medium + inputComplexity.High + inputComplexity.Low },
            { label: "Low", label_count: inputComplexity.Low },
            { label: "Medium", label_count: inputComplexity.Medium },
            { label: "High", label_count: inputComplexity.High }
        ],
          total_records: input.total_hits,
        };
      }

    const handleSubmit = async () => {
        //console.log("Text submitted:", text);
        //Clean Text without Tags
        const cleanText = DOMPurify.sanitize(text, {
            ALLOWED_TAGS: [],
            ALLOWED_ATTR: [],
          });



        if (!text.trim()) return; // Prevent submission of empty text

        //Prevent submission of text with tags
        if (cleanText !== text) {
            Toastify({
                text: "Invalid input: no tags allowed.",
                duration: 3000, // duration in milliseconds
                close: true, // show close button
                gravity: "top", // top or bottom
                position: "right", // left, center, or right
                backgroundColor: "#f00",
                stopOnFocus: true, // stop timeout on hover
              }).showToast();     
            return;
        }

        try {
            setIsLoading(true);
            const ts = Math.floor(Date.now() / 1000); // Get the current Unix timestamp

            const hmacStr = CLIENT_SECRET + CLIENT_ID + user.id.toString() + id.id.toString() + ts.toString();
            const hmacHash = crypto.SHA256(hmacStr).toString(crypto.enc.Hex);

          const formData = new FormData();
          formData.append('comment', cleanText.trim());
          formData.append('artifact_id', id.id);
          formData.append('user_id', user.id);
          formData.append('client_id', CLIENT_ID);
          formData.append('ts', ts);
          formData.append('hmac', hmacHash);
        
          const result = await axios.post(`${BASE_URL_API}task/save_follow_up_comments`, formData);

          if (result.data.code === 200) {
            setIsLoading(false);
            setText('');
            Toastify({
                text: "Comment added successfully.",
                duration: 3000, // duration in milliseconds
                close: true, // show close button
                gravity: "top", // top or bottom
                position: "right", // left, center, or right
                backgroundColor: "#198754",
                stopOnFocus: true, // stop timeout on hover
              }).showToast();
            setCommentCount(commentCount + 1);
          } else {
            setIsLoading(false);
            setText("");
            Toastify({
                text: "Something went wrong. Please try again.",
                duration: 3000, // duration in milliseconds
                close: true, // show close button
                gravity: "top", // top or bottom
                position: "right", // left, center, or right
                backgroundColor: "#f00",
                stopOnFocus: true, // stop timeout on hover
              }).showToast();
            //throw new Error(`API returned non-200 code: ${result.code}`);
          }
        } catch (error) {
            setIsLoading(false);
            setText("");
            Toastify({
                text: "Something went wrong. Please try again.",
                duration: 3000, // duration in milliseconds
                close: true, // show close button
                gravity: "top", // top or bottom
                position: "right", // left, center, or right
                backgroundColor: "#f00",
                stopOnFocus: true, // stop timeout on hover
              }).showToast();
          console.error("There was a problem fetching the tasks:", error);
        }
    };

    // Trigger handleRecords when sortValue changes
    
    useEffect(() => {
        const handleTaskRecords = async () => {
            try {
                
                setIsLoading(true);

              const ts = Math.floor(Date.now() / 1000); // Get the current Unix timestamp

              const hmacStr = CLIENT_SECRET + CLIENT_ID + id.id.toString() + ts.toString();
              const hmacHash = crypto.SHA256(hmacStr).toString(crypto.enc.Hex);

              //Previos Code Data Coming From Fast API
              const formData = new FormData();
              formData.append('artifact_id', id.id);
              formData.append('client_id', CLIENT_ID);
              formData.append('ts', ts);
              formData.append('hmac', hmacHash);
              
              const result = await axios.post(`${BASE_URL_API}artifact/details`, formData);
              
            //New code CDN API Calling
            // const artifactId  = [id.id]
            //New code CDN API Calling
            // const advanceFilter  = JSON.stringify({
            //     artifact_id : artifactId
            // })
            //New code CDN API Calling
            // const queryParams = {
            //     limit: 1,
            //     offset: 0,
            //     order_by: "desc",
            //     advance_filter: advanceFilter,
            //     client_id: CLIENT_ID,
            //     ts: ts,
            //     hmac: hmacHash
            // };
            //New code CDN API Calling
            // const queryString = new URLSearchParams(queryParams).toString();
            //New code CDN API Calling
            // const result = await axios.get(`${CDN_ELK_URL}/task/elk_caching?${queryString}`);

              if (result.data.code === 200) {
                if(result.data.secure) {
                    const encryptedData = await result.data.data;
                    const decryptedText = await decryptAES(encryptedData, DATA_DECRYPTION_KEY);
                    //New code CDN API Calling
                    // const flattenData = await JSON.parse(decryptedText); // Assuming decrypted data is JSON
                    // const output = transformData(flattenData) 
                    // setIsLoading(false);
                    // setTask(output.fetch_records[0]);
                    //Previous Code
                  const output = JSON.parse(decryptedText); // Assuming decrypted data is JSON
                //   console.log("output 152", output);
                  setIsLoading(false);
                  setTask(output[0]);
                } else {
                    
                    setIsLoading(false);
                    setTask(result.data.data[0]);
                }
                
                // console.log("Task", task)

              } else {
                setIsLoading(false);
                setTask([]);
                //throw new Error(`API returned non-200 code: ${result.code}`);
              }
            } catch (error) {
                setIsLoading(false);
                setTask([]);
              console.error("There was a problem fetching the tasks:", error);
            }
          };

          handleTaskRecords();
    }, [id.id]);

    useEffect(() => {
        const handleCommentRecords = async () => {
            try {
                setIsLoading(true);

                const ts = Math.floor(Date.now() / 1000); // Get the current Unix timestamp

                const hmacStr = CLIENT_SECRET + CLIENT_ID + id.id.toString() + ts.toString();
                const hmacHash = crypto.SHA256(hmacStr).toString(crypto.enc.Hex);

              const formData = new FormData();
              formData.append('artifact_id', id.id);
              formData.append('client_id', CLIENT_ID);
              formData.append('ts', ts);
              formData.append('hmac', hmacHash);
              
              const result = await axios.post(`${BASE_URL_API}artifact/followups`, formData);

              if (result.data.code === 200) {
                
                if(result.data.secure) {
                    const encryptedData = await result.data.data;
                    const decryptedText = await decryptAES(encryptedData, DATA_DECRYPTION_KEY);
                    const output = JSON.parse(decryptedText); // Assuming decrypted data is JSON
                
                    setIsLoading(false);
                    setComments(output);
                } else {
                    
                    setIsLoading(false);
                    setComments(result.data.data);
                }

              } else {
                setIsLoading(false);
                setComments([]);
                //throw new Error(`API returned non-200 code: ${result.code}`);
              }
            } catch (error) {
                setIsLoading(false);
                setComments([]);
              console.error("There was a problem fetching the tasks:", error);
            }
          };
          handleCommentRecords();
    }, [id.id, commentCount]);

    const handleSOPClick = () => {
        window.open(SOP_CDN_PATH, '_blank');
      };
  
    const handleUserManualClick = () => {
        window.open(USER_MANUAL_CONTRIBUTOR_CDN_PATH, '_blank');
    };

    const handleExcelClick = () =>{
        const link = document.createElement('a');
        link.href = GIGW_Web_Accessibility;
        link.download = ''; 
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const allowedArtifactIds = [500795, 500619, 496888];


    const labelMapping = {
        All: "All",
        Low: "Beginner",
        Medium: "Intermediate",
        High: "Advanced",
      };

    return(
        <>
            <Header/>
                <main className="custom-mt">
                    <div className="container mb-3 my-5" id="detail">
                        <div className="row top-fltr-btn" id="">
                        </div>
                        {
                        (isLoading)
                        ?
                        <SkeletonTheme baseColor="#ebebeb" highlightColor="#fff">
                              <div className="row">
                                  <Skeleton count={5} />
                                  <div className="d-flex align-items-center justify-content-center">
                                      <Skeleton className="p-2 m-2 shadow rounded-5" count={1} />
                                      <Skeleton className="p-2 m-2 shadow rounded-5" count={1} />
                                      <Skeleton className="p-2 m-2 shadow rounded-5" count={1} />
                                  </div>
                              </div>
                          </SkeletonTheme>
                        :
                        <div className="card  shadow card-main-mobs main-sectn">
                            <div className="mb-3">
                                <span className="badge badge-info text-dark text-decoration-none">{
                                (task.hasOwnProperty('category') && task.category.hasOwnProperty('value') && task.category.value.length > 0)
                                ? task.category.value.map((level, idx) => (
                                    <span key={`level-${idx}`}>{level}</span>
                                )):''
                            }</span>

                            </div>
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <h4 className="card-title">                                
                                {
                                (task.hasOwnProperty('title') && task.title.hasOwnProperty('value') && task.title.value.length > 0)
                                ? task.title.value.map((level, idx) => (
                                    <span key={`level-${idx}`}>{level}</span>
                                )):''
                            }</h4>

                            </div>

                            <div className="mb-3">
                                <span className="text-decoration-none badge bg-secondary me-2 custom-py" style={{color:'#185D4F'}}>Technologies:</span>
                                {
                                (task.hasOwnProperty('skills_and_expertise') && task.skills_and_expertise.hasOwnProperty('value') && task.skills_and_expertise.value.length > 0)
                                ? task.skills_and_expertise.value.map((level, idx) => (
                                        <span  className="text-decoration-none badge bg-light text-dark custom-py me-2" key={idx}>{level}</span>
                                 
                                )):''
                                }  
                            </div>

                            
                            <div className="row info-box mb-4">
                            <div className="col-md-6">
                                <div className=" btn-secondary mb-2 ">
                                    <img src={`${IMAGE_PATH}/corporate_fare.png`}className="icons-mntr" alt="corporate_fare.png"/><span
                                    className="box-dtl"><b>Publisher Details</b></span></div>
                                <p className="ms-4"> {
                                (task.hasOwnProperty('publisher_details') && task.publisher_details.hasOwnProperty('value') && task.publisher_details.value.length > 0)
                                ? task.publisher_details.value.map((level, idx) => (
                                    <span key={`level-${idx}`}>{level}</span>
                                )):''
                            }</p>
                                <p>
                                    <img src={`${IMAGE_PATH}/Clock.png`} className="icons-mntr" alt="Clock.png"/><strong className="box-dtl">Submission Date:</strong> {
                                        (task.hasOwnProperty('last_submission_date_1') && task.last_submission_date_1.hasOwnProperty('value') && task.last_submission_date_1.value.length > 0)
                                        ? task.last_submission_date_1.value.map((level, idx) => {
                                            // Parse the date string
                                            const date = new Date(level);
                                            const formattedDate = `${('0' + date.getDate()).slice(-2)}-${('0' + (date.getMonth() + 1)).slice(-2)}-${date.getFullYear()} `;
                                            
                                            return <span key={`level-${idx}`}>{formattedDate}</span>;
                                        }) : ''
                                    }</p>
                                <p><img src={`${IMAGE_PATH}/military_tech.png`} className="icons-mntr" alt="military_tech.png"/><strong className="box-dtl">Technical Skills</strong></p>
                                <ul>                                {
                                (task.hasOwnProperty('skills_and_expertise') && task.skills_and_expertise.hasOwnProperty('value') && task.skills_and_expertise.value.length > 0)
                                ? task.skills_and_expertise.value.map((level, idx) => (
                                    <li key={`level-${idx}`}>{level}</li>
                                )):''
                            }
                                </ul>
                            </div>
                            <div className="col-md-6">
                                
                                <p>
                                    <img src={`${IMAGE_PATH}/mentor.jpeg`} className="icons-mntr" alt="mentor.jpeg"/>
                                    <strong className="box-dtl ms-2">Mentor(s):</strong> {
                                (task.hasOwnProperty('mentor_s__1') && task.mentor_s__1.hasOwnProperty('value') && task.mentor_s__1.value.length > 0)
                                ? task.mentor_s__1.value.map((level, idx) => (
                                    <span key={`level-${idx}`}>{level}</span>
                                )):''
                            }</p>
                                
                                <p><span className="box-dtl"><strong>Complexity Level:</strong></span> {
                                (task.hasOwnProperty('complexity') && task.complexity.hasOwnProperty('value') && task.complexity.value.length > 0)
                                ? task.complexity.value.map((level, idx) => (
                                    <span key={`level-${idx}`}>{labelMapping[level?.trim()]}</span>
                                )):''
                            }</p>
                                <p><span className="box-dtl"><strong>Domain:</strong> </span>{
                                (task.hasOwnProperty('reference_url') && task.reference_url.hasOwnProperty('value') && task.reference_url.value.length > 0)
                                ? task.reference_url.value.map((level, idx) => (
                                    <span key={`level-${idx}`}>{level}</span>
                                )):''
                            }</p>

                            </div>
                            </div>
                            <div className="row align-items-center pdf-btns pdf-mob mb-4" id="update_list"style={{backgroundColor: "#EBF4F3", padding: "10px", borderRadius: "10px",}}>
                                 <div className="col-md-3 col-12 d-flex align-items-center" onClick={handleUserManualClick}>
                                    <div className="icon-circle me-3" >
                                        <img 
                                            src={`${IMAGE_PATH}/user_manual_v1.png`} 
                                            alt="User Manual Icon" 
                                            className="img-fluid" 
                                        />
                                   
                                    </div>
                                    <span class="contributor-text-mobiles ">User Manual for Contributor</span>
                                </div>
                                <div className="col-md-4 col-12 d-flex align-items-center mt-3 mt-md-0" onClick={handleSOPClick}>
                                    <div className="icon-circle me-3">
                                        <img 
                                            src={`${IMAGE_PATH}/user_manual_v1.png`} 
                                            alt="SOP Icon" 
                                            className="img-fluid" 
                                        />
                                     
                                    </div>
                                    <span class="contributor-text-mobiles ">Standard Operating Procedure (SOP)</span>
                                </div>
                            {allowedArtifactIds.includes(task.artifact_id) && (

                                <div className="col-md-4 col-12 d-flex align-items-center mt-3 mt-md-0 excel-download-icon" onClick={handleExcelClick}>
                                    <div className="icon-circle me-3">
                                        <img 
                                            src={`${IMAGE_PATH}/user_manual_v1.png`} 
                                            alt="Accessibility Icon" 
                                            className="img-fluid" 
                                        />
                                     
                                    </div>
                                    <span class="contributor-text-mobiles ">GIGW 3.0 Web Accessibility</span>
                                </div>
                            )}
                            </div>

                            <div className="mb-4">
                            <h1 style={{fontSize:'1rem'}}><b>Description</b></h1>
                            <p>
                            {
                                (task.hasOwnProperty('descriptions') && task.descriptions.hasOwnProperty('value') && task.descriptions.value.length > 0)
                                ? task.descriptions.value.map((level, idx) => (
                                    <span key={`level-${idx}`} dangerouslySetInnerHTML={{__html: level}}></span>
                                )):''
                            }  
                            </p>
                            </div>

                            
                            <div className="mb-4">
                            <h6><b>Goals</b></h6>
                            <p>{
                                (task.hasOwnProperty('what_you___ll_do') && task.what_you___ll_do.hasOwnProperty('value') && task.what_you___ll_do.value.length > 0)
                                ? task.what_you___ll_do.value.map((level, idx) => (
                                    <span key={`level-${idx}`} dangerouslySetInnerHTML={{__html: level}}></span>
                                )):''
                            }</p>
                            </div>

                            
                            <div className="mb-4">
                            <h6><b>Expected Outcome</b></h6>
                            <p>{
                                (task.hasOwnProperty('expected_outcome') && task.expected_outcome.hasOwnProperty('value') && task.expected_outcome.value.length > 0)
                                ? task.expected_outcome.value.map((level, idx) => (
                                    <span key={`level-${idx}`} dangerouslySetInnerHTML={{__html: level}}></span>
                                )):''
                            }
                            </p>
                            </div>
                            <div className="mb-4">
                            <h6><b>How To Submit</b></h6>
                            <p>{
                                (task.hasOwnProperty('how_to_submit') && task.how_to_submit.hasOwnProperty('value') && task.how_to_submit.value.length > 0)
                                ? task.how_to_submit.value.map((level, idx) => (
                                    <span key={`level-${idx}`} dangerouslySetInnerHTML={{__html: level}}></span>
                                )):''
                            }
                            </p>
                            </div>
                            <div className="container " style={{padding: "initial"}}>
                                <h4 className="ms-2 fs-5"><b>Follow Up</b></h4>
                                <div className="card">
                                    <div className="card-header followup-clr">
                                        <span></span> 
                                        {/* <div style={{textAlign: 'right'}}>
                                            <img src={`${IMAGE_PATH}/visibility.png`} className="icons-mntr" alt="visibility.png"/>
                                            <img src={`${IMAGE_PATH}/more_horiz.png`} className="icons-mntr" alt="more_horiz.png"/> 
                                        </div> */}
                                    </div>
                                    <div className="card-body textarea-box">
                                        <textarea 
                                        className="form-control" 
                                        placeholder="Write your Text" 
                                        rows="5" 
                                        style={{backgroundColor: '#8080804a'}}
                                        value={text} 
                                        onChange={(e) => setText(e.target.value)} 
                                        disabled={!isLoggedIn}></textarea>
                                        {
                                            (!isLoggedIn) 
                                            ?
                                            <p className="kindly-login" style={{color:'#A72020'}}>Kindly  
                                                <span onClick={handleLogin} className="login-restriction text-decoration-underline"  style={{color:'#185D4F'}}> Login</span> to add your text</p>
                                            :
                                            ''
                                        }
                                        {((isLoggedIn) && (text)) && (
                                            <button  
                                            className="btn btn-outline-success"
                                            style={{float: 'right', marginTop: '10px'}}
                                            onClick={handleSubmit}>
                                            Submit
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {
                                (Array.isArray(comments) && comments.length > 0) ? 
                                comments.filter(comment => comment.comment_body && comment.comment_body.trim() !== '') // Filter out comments with empty comment_body
                                    .map((comment, index) => (
                                        <Comment
                                            key={index} 
                                            comment={comment}
                                            isLoggedIn={isLoggedIn}
                                            BASE_URL_OPENFORGE={BASE_URL_OPENFORGE}
                                        />
                                    )) : ""
                            }
                            {
                                (!isLoggedIn)
                                ?
                                <div className="d-grid gap-2 col-2 mx-auto mt-2">
                                    <span onClick={handleLogin} className="btn btn-outline-success" style={{float: 'right', marginTop: '10px',whiteSpace: 'nowrap'}}>Join Now</span>
                                </div> 
                                :
                                ''
                            }
                        </div>
                        
                        }
                    </div>
                </main>
        </>
    )
});